import validationMessages from 'vee-validate/dist/locale/en';

/**
 * TODO Brian
 * TODO Consider pulling out the YES/NO option into its own object and injecting it so it's translated once
 */

const yesNoOptions = [
    {value: "Yes", text: "Yes"},
    {value: "No", text: "No"}
]

export default {
    form: {
        error: "Error",
        warning: "Warning",
        thankyou: "Thank you",
        click_here: "click here",
        errorLoading: "This form could not be loaded at this time, please try again later.",
        submissionProblem: "There was a problem submitting your data, to try again",
        submissionSuccess: "You will be forwarded in just a few seconds."
    },
    privacyLinkLabel: "Privacy Policy.",
    privacyLink: 'https://www.cloud.com/privacy-policy',
    privacyText: "Cloud Software Group will process your data according to our",
    privacyText2: "",
    resetText: "If the form is pre-filled and this is not you, please",
    resetText2: "to reset it.",
    resetLinkText: "click here",
    yes: "Yes",
    no: "No",
    submitBtn: {
        "Submit": "Submit",
        "Get the eBook": "Get the e-book",
        "Watch demo": "Watch demo",
        "Get the kit": "Get the kit",
        "Read the report": "Read the report",
        "Get the infographic": "Get the infographic",
        "Get the report": "Get the report",
        "Get the brief": "Get the brief",
        "View the webinar": "View the webinar",
        "Compare now": "Compare now",
        "Get the overview": "Get the overview",
        "Update Preferences": "Update Preferences",
        "Unsubscribe": "Unsubscribe",
        "Request a demo": "Request a demo",
        "Request a call": "Request a call"
    },
    apjPrivacy: {
        title: "How We Use Your Personal Information",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") will use and store your personal information pursuant to applicable data protection laws and regulations and",
        linkText: "Citrix Privacy Policy",
        part2: "and in circumstances where access is strictly restricted. Citrix will use your personal information only as prescribed by its Privacy Policy and not for any other purposes. In accordance with its Privacy Policy, Citrix may entrust processing of personal information to domestic or overseas business entities, share personal information with other Citrix offices or subsidiaries around the world, or send personal information to domestic or overseas third parties. When you submit your personal information to Citrix, you consent to the collection and processing of your personal information as described in Citrix Privacy Policy.",
        privacyAccept: "I have read and agree to the Citrix Privacy Policy"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Company"
        },
        "department": {
            label: "Department",
            options: [
                {value: "Application Management", text: "Application Management"},
                {value: "Consulting Services", text: "Consulting Services"},
                {value: "Education / Training", text: "Education / Training"},
                {value: "Engineering", text: "Engineering"},
                {value: "Executive Office / Administration", text: "Executive Office / Administration"},
                {value: "Finance / Accounting", text: "Finance / Accounting"},
                {value: "Human Resources", text: "Human Resources"},
                {value: "Information Technology - Systems", text: "Information Technology-Systems"},
                {value: "Legal", text: "Legal"},
                {value: "Marketing / PR", text: "Marketing / PR"},
                {value: "Networking", text: "Networking"},
                {value: "Operations / Manufacturing", text: "Operations / Manufacturing"},
                {value: "Pre-Sales / Technical Support", text: "Pre-Sales / Technical Support"},
                {value: "Project Management", text: "Project Management"},
                {value: "Purchasing", text: "Purchasing"},
                {value: "Sales / Bus-Corp Development", text: "Sales / Bus-Corp Development"},
                {value: "Security", text: "Security"},
                {value: "Web / Online / E-Business", text: "Web / Online / E-Business"}
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Industry",
            options: [
                {value: "Agriculture", text: "Agriculture"},
                {value: "Art & Membership", text: "Art & Membership"},
                {value: "Business Consulting", text: "Business Consulting"},
                {value: "Business/Personal Services", text: "Business/Personal Services"},
                {value: "Charitable/Non-Profit", text: "Charitable/Non-Profit"},
                {value: "Chemical Manufacturing", text: "Chemical Manufacturing"},
                {value: "Conglomerate", text: "Conglomerate"},
                {value: "Construction and Design", text: "Construction and Design"},
                {value: "Consumer Packaged Goods", text: "Consumer Packaged Goods"},
                {value: "E-Commerce", text: "E-Commerce"},
                {value: "Education", text: "Education"},
                {value: "Engineering", text: "Engineering"},
                {value: "Entertainment", text: "Entertainment"},
                {value: "Finance", text: "Finance"},
                {value: "Government/Local", text: "Government/Local"},
                {value: "Government/National-Federal", text: "Government/National-Federal"},
                {value: "Government/State-Province", text: "Government/State-Province"},
                {value: "Health Care", text: "Health Care"},
                {value: "Hospitality", text: "Hospitality"},
                {value: "Household Services", text: "Household Services"},
                {value: "Insurance", text: "Insurance"},
                {value: "Legal", text: "Legal"},
                {value: "Manufacturing", text: "Manufacturing"},
                {value: "Mining - All", text: "Mining - All"},
                {value: "Oil and Gas", text: "Oil and Gas"},
                {value: "Personnel Services", text: "Personnel Services"},
                {value: "Pharmaceuticals", text: "Pharmaceuticals"},
                {value: "Professional Services", text: "Professional Services"},
                {value: "Publishing/Printing", text: "Publishing/Printing"},
                {value: "Real Estate", text: "Real Estate"},
                {value: "Retail/Wholesale", text: "Retail/Wholesale"},
                {value: "Service Provider", text: "Service Provider"},
                {value: "Technology", text: "Technology"},
                {value: "Telecommunication", text: "Telecommunication"},
                {value: "Transportation", text: "Transportation"},
                {value: "Utilities", text: "Utilities"}
            ]
        },
        "NumberOfEmployees_Self_Reported__c": {
            label: "Company size",
            options: [
                {value: "50", text: "1-50"},
                {value: "500", text: "51-500"},
                {value: "749", text: "501-749"},
                {value: "4999", text: "750-4,999"},
                {value: "19999", text: "5,000-19,999"},
                {value: "20000", text: "20,000+"}
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Company size"
        },
        "Address2": {
            label: "Address Line 2"
        },
        "Address3": {
            label: "Address Line 3"
        },
        "city": {
            label: "City"
        },
        "country": {
            label: "Country"
        },
        "email": {
            label: "Work email"
        },
        "firstName": {
            label: "First name"
        },
        "lastName": {
            label: "Last name"
        },
        "phone": {
            label: "Phone number"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Zip/Postal code"
        },
        "salutation": {
            label: "Salutation",
            options: [
                {value: "Dr.", text: "Dr."},
                {value: "Egr. Sig.", text: "Egr. Sig."},
                {value: "Frau", text: "Frau"},
                {value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                {value: "Herr", text: "Herr"},
                {value: "Madame", text: "Madame"},
                {value: "Mademoiselle", text: "Mademoiselle"},
                {value: "Miss", text: "Miss"},
                {value: "Monsieur", text: "Monsieur"},
                {value: "Mr.", text: "Mr."},
                {value: "Mrs.", text: "Mrs."},
                {value: "Ms.", text: "Ms."},
                {value: "Professor", text: "Professor"},
                {value: "Señor", text: "Señor"},
                {value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "State/Province"
        },
        "address": {
            label: "Address"
        },
        "Job_Title__c": {
            label: "Job title",
            options: [
                {value: "Analyst", text: "Analyst"},
                {value: "Architect", text: "Architect"},
                {value: "Assistant", text: "Assistant"},
                {value: "Business Manager", text: "Business Manager"},
                {value: "C-Level / President / VP", text: "C-Level / President / VP"},
                {value: "Consultant", text: "Consultant"},
                {value: "Director", text: "Director"},
                {value: "Developer / Programmer", text: "Developer / Programmer"},
                {value: "IT Manager", text: "IT Manager"},
                {value: "Network Administrator / Engineer", text: "Network Administrator / Engineer"},
                {value: "Owner / Partner", text: "Owner / Partner"},
                {value: "Student", text: "Student"},
                {value: "System Administrator", text: "System Administrator"}
            ]
        },
        "Project_Budget__c": {
            label: "Project budget",
            options: [
                {value: "Yes", text: "Yes"},
                {value: "No", text: "No"},
                {value: "Unknown", text: "Unknown"}
            ]
        },
        "Primary_Product_Interest__c": {
            label: "Product interest (CTRL to select more than one choice (max 5 choices))",
            options: [
                {value: "Citrix ADC", text: "Citrix ADC"},
                {value: "Citrix Analytics", text: "Citrix Analytics"},
                {value: "Citrix Application Delivery Management", text: "Citrix Application Delivery Management"},
                {value: "Citrix App Delivery and Security service", text: "Citrix App Delivery and Security service"},
                {value: "Citrix DaaS", text: "Citrix DaaS"},
                {value: "Citrix Gateway", text: "Citrix Gateway"},
                {value: "Citrix Hypervisor", text: "Citrix Hypervisor"},
                {value: "Citrix Podio", text: "Citrix Podio"},
                {value: "Citrix SD-WAN", text: "Citrix SD-WAN"},
                {value: "Citrix Secure Internet Access", text: "Citrix Secure Internet Access"},
                {value: "Citrix Secure Private Access", text: "Citrix Secure Private Access"},
                {value: "Citrix Virtual Apps and Desktops", text: "Citrix Virtual Apps and Desktops"},
                {value: "Citrix Web App and API Protection", text: "Citrix Web App and API Protection"},
                {value: "Consulting Services", text: "Consulting Services"},
                {value: "RightSignature", text: "RightSignature"},
                {value: "Support", text: "Customer Success Programs"},
                {value: "Training", text: "Premium Training"}
            ]
        },
        "Purchase_Timeframe__c": {
            label: "Purchase time frame",
            options: [
                {value: "3 months or less", text: "3 months or less"},
                {value: "4 to 6 months", text: "4 to 6 months"},
                {value: "7 months or more", text: "7 months or more"},
                {value: "No time frame", text: "No time frame"},
                {value: "Unknown", text: "Uncertain"}
            ]
        },
        "Email_Blast_OK__c": {
            label: "May we send you emails?",
            options: [
                {value: "Yes", text: "Yes"},
                {value: "No", text: "No"}
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                {value: "Yes", text: "Yes"},
                {value: "No", text: "No"}
            ]
        },
        "OK_to_Call__c": {
            label: "May we call you by phone?",
            options: [
                {value: "Yes", text: "Yes"},
                {value: "No", text: "No"}
            ]
        },

        "Preferred_Language__c": {
            label: "Preferred language",
            options: [
                {value: "English", text: "English"},
                {value: "French", text: "French"},
                {value: "Spanish", text: "Spanish"},
                {value: "Cantonese (Chinese)", text: "Cantonese (Chinese)"},
                {value: "Mandarin (Chinese)", text: "Mandarin (Chinese)"},
                {value: "Bahasa", text: "Bahasa"},
                {value: "German", text: "German"},
                {value: "Italian", text: "Italian"},
                {value: "Japanese", text: "Japanese"},
                {value: "Korean", text: "Korean"},
                {value: "Portuguese", text: "Portuguese"},
                {value: "Russian", text: "Russian"},
                {value: "Other", text: "Other"}
            ]
        },
        "Sales_Contact_Requested__c": {
            label: "Have a Sales Person contact me"
        },
        "Comments_6__c": {
            label: "Comments"
        },
        "Comments__c": {
            label: "Comments"
        },

        //PrefCenter fields/options
        "Unsubscribed": {
            label: "Unsubscribe from all Citrix email marketing messages.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "Suspend communication for 30 days.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "How complete digital workspaces—including apps, desktops, files and mobile devices—help you do your best work from wherever you are.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "How to securely access all apps, desktops and data from any device.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "How to manage monolithic and microservices based app delivery in a hybrid, multi-cloud world.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "How to deliver the always-on, high-performance network your users need.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "How to detect security threats and performance anomalies with analytics and insights to stop them before they happen.",
            options: [...yesNoOptions]
        }
    },
    validation: {
        messages: Object.assign(validationMessages.messages, {
            required: (field) => `${field} is required.`,
        })
    },
    preferenceCenter: {
        formTitle: "Citrix Email Preference Center",
        thankyou: "<h3>Subscription Changes Confirmed!</h3><p>Your email preferences have been updated.</p>",
        formDescription: "Your email and communication preferences are important to us. We want to send you information that helps you and your organization power a better way to work.  Update your email preferences so we can ensure that you receive communications from Citrix that you care about.",
        labelOne: "Tell us more about you",
        labelTwo: "Which topics are you interested in hearing about?",
        labelThree: "How would you like to be communicated with?",
        unsubscribeMsg: "Unsubscribing from marketing emails, will also unsubscribe you from receiving emails about topics you have checked in the preference section above.",
        
    },
    optOut: {
        formTitle: "Unsubscribe",
        thankyou: "Your email preferences have been updated. If this was done by mistake or you would like to review your preferences, please visit our Preference Center at any time.",
        formDescription: "Enter your email address to discontinue Citrix email marketing messages.",
        labelOne: "Tell us more about you",
        labelTwo: "Which topics are you interested in hearing about?",
        labelThree: "How would you like to be communicated with?"
    }
}